import { useMemo } from 'react'
import { filterDetailRowIndices, hasActiveColumnFilters } from '../utils/detailFilterUtils'
import { sortRowIndices, type SortSpec } from '../utils/detailSortUtils'

export interface UseDetailRowPipelineOptions {
  detailRows: Record<string, string>[]
  columnFilters: Record<string, string>
  sortSpec: SortSpec | null
  detailReviewed?: boolean[]
  detailReviewMemos?: (string | null)[]
}

export interface DetailRowPipelineResult {
  /** 絞込後の行インデックス（元配列基準） */
  visibleRowIndices: number[]
  /** 絞込 + ソート後の表示用行インデックス */
  displayRowIndices: number[]
  hasActiveFilter: boolean
}

export function useDetailRowPipeline({
  detailRows,
  columnFilters,
  sortSpec,
  detailReviewed,
  detailReviewMemos,
}: UseDetailRowPipelineOptions): DetailRowPipelineResult {
  const visibleRowIndices = useMemo(
    () => filterDetailRowIndices(detailRows, columnFilters, { detailReviewed, detailReviewMemos }),
    [detailRows, columnFilters, detailReviewed, detailReviewMemos],
  )

  const hasActiveFilter = useMemo(
    () => hasActiveColumnFilters(columnFilters),
    [columnFilters],
  )

  const displayRowIndices = useMemo(
    () => sortRowIndices(visibleRowIndices, sortSpec, {
      detailRows,
      detailReviewed,
      detailReviewMemos,
    }),
    [visibleRowIndices, sortSpec, detailRows, detailReviewed, detailReviewMemos],
  )

  return { visibleRowIndices, displayRowIndices, hasActiveFilter }
}

export default useDetailRowPipeline
